import * as React from 'react';
import { createView } from '@sail/engine';
import { view, css } from '@sail/ui';
import { helmTokens } from '../theme';
const hoverArrowStyles = css({
    position: 'relative',
    top: '1px',
    marginLeft: '5px',
    fill: 'none',
    stroke: 'currentColor'
});
const hoverArrowUnprocessedStyles = css({
    strokeWidth: '2px'
});
const hoverArrowLinePathStyles = css({
    opacity: '0',
    transition: `opacity ${helmTokens.transition.hover}`,
    '.CtaButton:hover:not([aria-disabled="true"]) &': {
        opacity: '1'
    }
});
const hoverArrowTipPathStyles = css({
    transform: 'none',
    transition: `transform ${helmTokens.transition.hover}`,
    '.CtaButton:hover:not([aria-disabled="true"]) &': {
        transform: 'translateX(3px)'
    }
});
/**
 * TODO: Write a brief description of the HoverArrow component
 */ export const HoverArrow = createView(()=>{
    return /*#__PURE__*/ React.createElement(view.svg, {
        className: "HoverArrow",
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        "aria-hidden": "true",
        uses: [
            hoverArrowStyles,
            hoverArrowUnprocessedStyles
        ]
    }, /*#__PURE__*/ React.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement(view.path, {
        className: "HoverArrow__linePath",
        d: "M0 5h7",
        uses: [
            hoverArrowLinePathStyles
        ]
    }), /*#__PURE__*/ React.createElement(view.path, {
        className: "HoverArrow__tipPath",
        d: "M1 1l4 4-4 4",
        uses: [
            hoverArrowTipPathStyles
        ]
    })));
});

//# sourceMappingURL=HoverArrow.js.map